import {
  PostValidationRequestDocumentsParams,
  ValidationRequestDocumentStatusResponse,
  ValidationRequestDocumentsServiceCapabilities
} from './ValidationRequestDocuments.types'

export const validationRequestDocumentsService = ({
  percentClient
}: ValidationRequestDocumentsServiceCapabilities) => ({
  getValidationRequestDocumentStatus: (validationRequestToken?: string) =>
    percentClient.get<ValidationRequestDocumentStatusResponse>('v1/validation-request-documents/status', {
      params: { validationRequestToken }
    }),
  postValidationRequestDocuments: ({ validationRequestToken, formData }: PostValidationRequestDocumentsParams) =>
    percentClient.post('v1/validation-request-documents', formData, { params: { validationRequestToken } })
})
